import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AddToCartArgs, addToCart } from '../../api/cart/add-to-cart';
import syncCartCache from './sync-cart-cache';

type UseAddToCartOptions = { shouldSyncCartOnSuccess?: boolean };

const useAddToCart = ({ shouldSyncCartOnSuccess = true }: UseAddToCartOptions = {}) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (args: AddToCartArgs) => addToCart(args),
        onSuccess: (cart) => shouldSyncCartOnSuccess && syncCartCache(queryClient, cart)
    });
};

export default useAddToCart;
